
import offerOwnershipCost from "~/apollo/queries/offer/ownershipCost";
import {mapActions} from "vuex";
import TippyQuestion from "../tippy/tippy-question.vue";

export default {
  components: {TippyQuestion},
  props: ['offer'],
  data() {
    return {
      summ: null,
      total: null,
      offerData: null,
      all_data: [],
      sections: [],
      colors: ['#005ff9', '#ed7b29', '#0dc268', '#ed2939']
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions({
      request: 'request'
    }),
    toRubles(number) {
      return (
          String(Math.round(number)).replace(
              /(\d)(?=(\d\d\d)+([^\d]|$))/g,
              '$1 '
          ) + ' ₽'
      )
    },
    precentage(value){
     return  Math.floor(+value / this.summ * 100)
    },
    editSumm(item) {
      if (!item.dis && this.sections.length > 1) {
        item.dis = true
        this.summ = this.summ - item.value
        this.sections = this.sections.filter((el) => el.value !== item.value && item.dis)
      } else if (item.dis && this.sections.length >= 1) {
        delete item.dis
        this.summ = this.summ + item.value
        return this.sections.push(item)
      }
    },
    async getData() {
      try {
        await this.request({
          query: offerOwnershipCost,
          variables: {
            mark_slug: this.$route.params.mark,
            folder_slug: this.$route.params.model,
            external_id: Number(this.$route.params.car),
            day: 365
          }
        }).then(response => {
          this.offerData = response.data.offerOwnershipCost.items;
          this.offerData.forEach((el, ind) => this.sections.push({
            label: el.label + ' ' + this.toRubles(el.value),
            text: el.label + ' <span>' + this.toRubles(el.value) + '</span>',
            value: el.value,
            color: this.colors[ind],
          }))
          this.all_data = this.sections
        })
      } catch (error) {
        console.log(error);
      }
    }
  },
  watch: {
    'offerData'() {
      return this.offerData.forEach(el => this.summ += el.value)
    },
    'summ'() {
      this.total = this.summ
    }
  }
};
